// Bare: condenses the header inward on scroll. Deliberately independent of
// Dawn's stock sticky-header hide/reveal logic (which gates its
// `scrolled-past-header` class behind an IntersectionObserver-computed
// `headerBounds` value, and can end up never toggling if that observer
// doesn't fire promptly) — a plain scroll-position threshold, applied
// directly with no rAF/IO indirection, is simpler and more reliable for a
// purely visual condense effect. The toggled class only touches
// margin/border/radius (see bare-theme.css), so an unthrottled listener
// costs nothing meaningful per scroll event.
(function () {
  const header = document.querySelector('.section-header');
  if (!header) return;

  const THRESHOLD = 24;

  function update() {
    header.classList.toggle('bare-header--condensed', window.scrollY > THRESHOLD);
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
})();
